// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { type MutateOptions, useMutation } from '@tanstack/react-query'

import { type Enrollment, type SubmissionMethod } from '../../brokers/types'
import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

type EnrollmentPatchParam = {
  plan_code?: string
  off_exchange?: boolean
  quoted_premium?: string
  submission_method?: SubmissionMethod
  expected_payment_date_offset?: number
  payment_method_id?: string
  submitting_brokerage_id?: string
  brokerage_of_record_id?: string
  coverage_audit_reason?: string
  category?: string
  reimbursement_only_at?: string | null
  ancestor_enrollment_id?: string
  exchange_policy_id?: string
  max_premium_reimbursement_amount?: string
  autopay_state?: string
  carrier_member_id?: string
  enrollment_event_id?: string
  state_action?: string
  set_binder_paid?: boolean
}

export type EnrollmentMutateOptions =
  | MutateOptions<Enrollment, GrapeAPIErrorType, EnrollmentPatchParam, unknown>
  | undefined

export function useModifyEnrollment ({
  enrollmentId,
  memberId,
}: {
  enrollmentId: string
  memberId: string
}) {
  return useMutation<Enrollment, GrapeAPIErrorType, EnrollmentPatchParam>({
    mutationFn: async (params) => {
      const request = new FetchRequest(
        'put',
        `/api/web/brokers/members/${memberId}/enrollments/${enrollmentId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: {
            ...params,
          },
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
  })
}
